<script lang="ts">
	export let title = '';
</script>

<div class="container mx-auto min-h-screen px-4">
	{#if title}
		<div class="mb-8">
			<div class="mb-4 flex flex-col items-center justify-between gap-4">
				<h1 id="title" class="text-center font-bold">
					<a href="#title">{title}</a>
				</h1>
				{#if $$slots.extra}<slot name="extra" />{/if}
				<slot name="navigation" />
			</div>
			<span id="subtitle"><a href="#subtitle"><slot name="subtitle" /></a></span>
		</div>
	{:else}
		<slot name="title" />
		<slot name="navigation" />
	{/if}
	<slot />
</div>
